<div class="splash-layout-page">
  <router-outlet></router-outlet>
</div>
